import React from 'react';
import {
  type EnterpriseFeatureFlagOverride,
  getEnterpriseFeatureFlagOverrides
} from '~/common/api-client';
import useAPI, { type State as BaseState } from '~/common/hooks/useAPI';

interface State
  extends Omit<
    BaseState<{ overrides: EnterpriseFeatureFlagOverride[]; total: number }>,
    'data'
  > {
  overrides: EnterpriseFeatureFlagOverride[];
  total: number;
  refresh: () => void;
}

interface Params {
  token: string;
  feature_ids?: string[];
  page: number;
  limit: number;
  sort_by?: string;
  sort_direction?: 'ASC' | 'DESC';
}

const useEnterpriseFeatureFlagOverrides = (params: Params): State => {
  const { token, feature_ids, page, limit, sort_by, sort_direction } = params;
  const featureIdsKey = feature_ids?.join(',');
  const dataLoader = React.useCallback(
    () =>
      getEnterpriseFeatureFlagOverrides({
        token,
        feature_ids,
        page,
        limit,
        sort_by,
        sort_direction
      }),
    [token, featureIdsKey, page, limit, sort_by, sort_direction]
  );
  const state = useAPI(dataLoader);
  return {
    error: state.error,
    loading: state.loading,
    overrides: state.data?.overrides || [],
    total: state.data?.total || 0,
    refresh: state.refresh
  };
};

export default useEnterpriseFeatureFlagOverrides;
